/**
 * Sí flag es true y el rol se encuentra en allowedRoles se muestra el componente ( solo n)
 * Sí flag es false y el rol se encuentra en allowedRoles no se muestra el componente (todos menos n)
 * @param flag
 * @param allowedRoles
 * @param children
 * @returns {*}
 * @constructor
 */
export default function AclRequired ({ flag, allowedRoles,children }) {

    /**
     * @param acl permisos de usuario
     * @param acl.excepcion
     * */

    const acl = JSON.parse(sessionStorage.getItem("acl"));
    const role = Object.keys(acl);
    const recurso = acl.excepcion ? Object.values(acl.excepcion) : [""];

    /*Sí se encuentra los roles permitidos 'allowedRoles' dentro del arreglo de 'role' o 'recurso'
     se renderiza el componente children*/

    // includes() recorre todo el array y no comprara objetos
    //function RoleExist(){
        let existe = false;
        for (const buscarRole of allowedRoles) {
            existe = role.includes(buscarRole) || recurso.includes(buscarRole);
            if ( existe && flag) {
                //localStorage.setItem('existe', JSON.stringify(existe));
                //break;
                return children;
            } else if (!existe && !flag) {
                return children;
            }
        }
      //  return existe;
    //}

    // return (
    //     RoleExist(allowedRoles, role, recurso) && children
    // );
}
